export const FULL_GLOBE = "127420000";
export const stationDetailsZoom = 15;
export const initialZoom = 11;
export const desc_min_zoom = 7;
export const mob_min_zoom = 5;
export const maxZoom = 20;
export const tab_max_width = 1024;

export const containerStyle = {
  width: "100%",
  height: "calc(100dvh - 68px)",
};

export const initialCenter = {
  lat: 37.7749,
  lng: -122.4194,
};

export const REGIONS_FOR_FAHRENHEIT = ["US", "LR", "MM"];

export const latLngBounds = {
  north: 85,
  south: -85,
  west: -180,
  east: 180,
};

export const AIRPORT_TYPES = {
  SMALL: "small_airport",
  MEDIUM: "medium_airport",
  LARGE: "large_airport",
  HELIPORT: "heliport",
  CLOSED: "closed",
} as const;

export const AIRPORT_ICONS = {
  small_airport: "/mapIcons/Small.svg",
  medium_airport: "/mapIcons/Medium.svg",
  large_airport: "/mapIcons/Large.svg",
  heliport: "/mapIcons/Heliport.svg",
  seaplane_base: "/mapIcons/Seaplane.svg",
  closed: "/mapIcons/Closed.svg",
  default: "/mapIcons/Default.svg",
} as const;
